import Home from './Home'
import HomeHeader from './HomeHeader'
import HomeHelp from './HomeHelp'

export default {
  default: Home,
  header: HomeHeader,
  help: HomeHelp,
}
